module.exports = __webpack_public_path__ + "intro-image.jpg";